module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-hover-small.eef29f69.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-hover-small.png
// module id = 2639
// module chunks = 11